import colors from '../../../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        actionRow: {
            '& > button': {
                marginLeft: 'auto'
            },
            height: '100%',
            justifyContent: 'space-between',
            padding: '16px 24px'
        },
        bold: {
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 900,
        },
        button: {
            '&.MuiButton-root': {
                border: '1px solid #006AC3',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                height: '40px',
                marginLeft: '10px',
                width: '104px'
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)'
            }
        },
        buttonContainer: {
            '@media screen and (max-width: 320px)': {
                paddingBottom: '20px'
            },
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            justifyContent: 'flex-end',
        },
        buttonSkip: {
            '&.MuiButton-root': {
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: colors[mode].primaryText,
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                textTransform: 'uppercase',
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)'
            }
        },
        buttonSubmit: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                border: '1px solid #FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                textTransform: 'uppercase',
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)',
                opacity: '0.5'
            }
        },
        checkbox: {
            '& .MuiSvgIcon-root': { 
                fontSize: '18px' 
            },
            '&.Mui-checked': {
                color: colors[mode].buttonColor,
            },
            '&.Mui-focusVisible': {
                outline: 'none'
            },
            color: colors[mode].checkboxBorder2,
        },
        checkboxContainer: {
            marginLeft: '4px'
        },
        checkCircle: {
            height: '32px',
            width: '32px'
        },
        content: {
            color: '#0267FF',
            fontSize: '24px',
            fontWeight: '500'
        },
        contentContainer: {
            backgroundColor: 'white',
            borderRadius: '3px',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            color: 'black'
        },
        contentDivider: {
            paddingTop: '25px'
        },
        contentSection: {
            color: 'black',
            fontSize: '20px'
        },
        divider: {
            background: '#FFC72A',
            padding: '2px',
            width: '50px'
        },
        fieldsContainer: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            width: '100%'
        },
        italics: {
            fontStyle: 'italic'
        },
        loader: {
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%',
            'z-index': '10'
        },
        mfaDesc: {
            color: 'rgba(0,0,0,0.54)',
            fontSize: '14px'
        },
        mfaEnrollmentContainer: {
            backgroundColor: colors[mode].primaryBackground,
            padding: '0px 24px',
        },
        mfaListContainer: {
            paddingTop: '20px'
        },
        mfaLogo: {
            height: '32px',
            width: '32px'
        },
        mfaLogoContainer: {
            alignItems: 'flex-start',
            display: 'flex'
        },
        mfaSetupTitle: {
            color: 'rgba(0,0,0,0.87)',
            fontSize: '16px',
            height: '24px',
            letterSpacing: '0',
            lineHeight: '24px',
            marginBottom: '10px',
            paddingTop: '20px'
        },
        mfaTitle: {
            color: 'rgba(0,0,0,0.87)',
            font: 'Roboto',
            fontSize: '16px',
            fontWeight: 500,
        },
        mfaTitleDesc: {
            minHeight: '76px'
        },
        mobileIcon: {
            alignItems: 'center',
            color: colors[mode].mobileIcon,
            display: 'flex',
            gap: '8px'
        },
        rememberMeContainer: {
            marginBottom: '16px',
            marginTop: '10px'
        },
        skipEnrollment: {
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            paddingLeft: '8px',
            paddingTop: '12px',
            whiteSpace: 'pre-line'
        },
        verbiageContainer: {
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            paddingTop: '16px',
            whiteSpace: 'pre-line'
        },
        verbiageDiv: {
            alignItems: 'center',
            color: colors[mode].secondaryText,
            display: 'flex',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            gap: '8px',
            marginBottom: '24px'
        },
        verbiageDivBottom: {
            alignItems: 'center',
            color: colors[mode].secondaryText,
            display: 'flex',
            gap: '8px',
        },
        verbiageText: {
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
        },
        warningLine: {
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            paddingBottom: '16px',
            paddingTop: '10px',
        }
    }
}
export default styles
